<template>
  <button @click="exportCommission" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCommission: async function () {
      this.filter.from = moment(this.filter.time).startOf('month').format('x');
      this.filter.to = moment(this.filter.time).endOf('month').format('x');
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      sheet.columns = [
        {header: this.$t('department'), key: 'department', width: 15},
        {header: this.$t('group'), key: 'group', width: 15},
        {header: this.$t('adminUser'), key: 'user', width: 30},
        {header: this.$t('client'), key: 'client', width: 60},
        {header: this.$t('baseCallFee'), key: 'baseCallFee', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('planOrderType'), key: 'planOrderType', width: 15},
        {header: this.$t('numberOfUser'), key: 'numberOfUser', width: 15},
        {header: this.$t('userPrice'), key: 'userPrice', width: 15},
        {header: this.$t('monthCount'), key: 'monthCount', width: 15},
        {header: this.$t('discount'), key: 'discount', width: 15},
        {header: this.$t('planOrderValue'), key: 'planOrderValue', width: 15},
        {header: this.$t('agencyCommission'), key: 'agencyCommission', width: 15},
        {header: this.$t('amountToGetCommission'), key: 'amountToGetCommission', width: 15},
        {header: this.$t('role'), key: 'role', width: 15},
        {header: this.$t('percent'), key: 'percent', width: 15},
        {header: this.$t('commissionValue'), key: 'commissionValue', width: 15},
      ];

      let users = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 50;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/admin-user/', {
          params: params
        });
        params.page += 1;
        users = result.data;
        if (users.docs && users.docs.length) {
          for (let user of users.docs) {
            if (['sales', 'kpiSales', 'supervisor', 'manager', 'account', 'operationsManager'].includes(user.role)) {
              //licence
              let response = await this.$bgService.get(`/commission/license/${user._id}`, {
                params: this.filter
              });
              if (response.data && response.data.length) {
                for (let commission of response.data) {
                  let row = {
                    department: user.department ? user.department.name : '',
                    group: user.group ? user.group.name : '',
                    user: user.name + ' (' + user.email + ')',
                    client: `${commission.companyName} - ${commission.domain}`,
                    createTime: moment(commission.createTime).format('DD/MM/YYYY HH:mm:ss'),
                    planOrderType: this.$t(commission.planOrderType),
                    numberOfUser: commission.numberOfUser,
                    userPrice: commission.userPrice,
                    monthCount: commission.monthCount,
                    discount: commission.discount,
                    planOrderValue: commission.planOrderValue,
                    agencyCommission: commission.agencyCommission,
                    amountToGetCommission: commission.planOrderValue - commission.agencyCommission,
                    role: this.$t(commission.role),
                    percent: commission.percent,
                    commissionValue: Math.floor(commission.percent * (commission.planOrderValue - commission.agencyCommission) / 100)
                  }
                  sheet.addRow(row);
                }
              }

              //call fee
              this.filter.role = user.role;
              let response2 = await this.$bgService.get(`/commission/call-fee/${user._id}`, {
                params: this.filter
              });
              if (response2.data && response2.data.length) {
                for (let commission of response2.data) {
                  let atgc = 0
                  if (['operationsManager', 'account'].includes(user.role)) {
                    atgc = commission.regularCallFee + commission.packageCallFee
                  } else if (commission.client.baseCallFee) {
                    atgc = commission.regularCallFee + commission.packageCallFee > commission.client.baseCallFee ? commission.regularCallFee + commission.packageCallFee - commission.client.baseCallFee : 0
                  } else {
                    atgc = commission.regularCallFee + commission.packageCallFee
                  }
                  atgc = atgc / 11 * 10
                  let totalCallFee = {
                    department: user.department ? user.department.name : '',
                    group: user.group ? user.group.name : '',
                    user: user.name + ' (' + user.email + ')',
                    client: `${commission.client.companyName} - ${commission.client.domain}`,
                    baseCallFee: commission.client.baseCallFee ? commission.client.baseCallFee : 0,
                    planOrderType: this.$t('callFee'),
                    planOrderValue: commission.regularCallFee + commission.packageCallFee,
                    amountToGetCommission: atgc,
                    role: this.$t('callFee'),
                    percent: commission.percent,
                    commissionValue: commission.percent * atgc / 100
                  }
                  sheet.addRow(totalCallFee);
                  if (commission.regularCallFee) {
                    let regularCallFee = {
                      department: user.department ? user.department.name : '',
                      group: user.group ? user.group.name : '',
                      user: user.name + ' (' + user.email + ')',
                      client: `${commission.client.companyName} - ${commission.client.domain}`,
                      planOrderType: this.$t('regularCallFee'),
                      planOrderValue: commission.regularCallFee,
                      role: this.$t('callFee'),
                    }
                    sheet.addRow(regularCallFee)
                  }
                  if (commission.packageCallFee && commission.clientPackages && commission.clientPackages.length) {
                    for (let p of commission.clientPackages) {
                      let detail = {
                        department: user.department ? user.department.name : '',
                        group: user.group ? user.group.name : '',
                        user: user.name + ' (' + user.email + ')',
                        client: `${commission.client.companyName} - ${commission.client.domain}`,
                        planOrderType: this.$t('packageCallFee'),
                        numberOfUser: p.limit,
                        userPrice: this.$store.state.user.planFee,
                        monthCount: p.monthCount,
                        planOrderValue: p.total,
                        role: this.$t('callFee'),
                      }
                      sheet.addRow(detail)
                    }
                  }
                }
              }
              this.filter.role = null;
            }
            this.downloadedCount += 1;
          }
        }
      } while (users && users.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'commission.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        });
      }
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      vi: {
        department: 'Phòng',
        group: 'Nhóm',
        adminUser: 'Nhân viên',
        client: 'Khách hàng - Domain',
        createTime: 'Tạo lúc',
        planOrderType: 'Loại đơn hàng',
        numberOfUser: 'Số user',
        userPrice: 'Giá/user',
        monthCount: 'Số tháng',
        discount: 'Giảm giá',
        planOrderValue: 'Giá trị đơn hàng',
        agencyCommission: 'Hoa hồng đại lý',
        amountToGetCommission: 'Doanh thu tính hoa hồng',
        role: 'Loại hoa hồng',
        percent: '% hoa hồng',
        commissionValue: 'Số tiền hoa hồng',
        new: 'Mua mới',
        user: 'Mua thêm user',
        extend: 'Gia hạn',
        upgrade: 'Nâng cấp',
        setup: 'Cài đặt',
        callFee: 'Cước gọi',
        sales: 'Sales',
        supervisor: 'Trưởng nhóm',
        manager: 'Trưởng phòng',
        account: 'Account',
        operationsManager: 'TP vận hành',
        exportingData: 'Xuất dữ liệu hoa hồng',
        exportNotice: 'Đợi tí, sắp xong òy...',
        baseCallFee: 'Cước gọi nền',
        regularCallFee: 'Cước gọi thông thường',
        packageCallFee: 'Cước gọi trọn gói'
      },
      en: {
        department: 'Department',
        group: 'Group',
        user: 'User',
        client: 'Client - domain',
        createTime: 'Create time',
        planOrderType: 'Plan order type',
        numberOfUser: 'Number of user',
        userPrice: 'User price',
        monthCount: 'Month count',
        discount: 'Discount',
        planOrderValue: 'Plan order value',
        agencyCommission: 'Agency commission',
        amountToGetCommission: 'Amount to get commission',
        role: 'Commission type',
        percent: 'Commission percent',
        commissionValue: 'Commission value',
        sales: 'Sales',
        supervisor: 'Supervisor',
        manager: 'Manager',
        account: 'Account',
        operationsManager: 'Operations manager',
        exportingData: 'Exporting commission data',
        exportNotice: 'Please wait a bit, it will be done soon...',
        baseCallFee: 'Base call fee',
        regularCallFee: 'Regular call fee',
        packageCallFee: 'Package call fee'
      }
    }
  }
}
</script>
